<div class="events-table-container">
  <table class="table table-striped table-hover table-bordered">
    <thead class="table-header">
      <tr>
        <th class="text-start">{{_apolusService.literals.EventType}}</th>
        <th class="text-center">{{_apolusService.literals.Quantity}}</th>
        <th class="text-center">{{_apolusService.literals.Percentage}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let event of data; let i = index" class="table-row">
        <td class="event-type-cell">
          <div class="d-flex align-items-center">
            <i class="fa fa-download mr-2" style="cursor: pointer;"></i>
            <span class="event-name">{{ event.AlarmDescription }}</span>
          </div>
        </td>
        <td class="text-center">{{ event.Quantity }}</td>
        <td class="text-center">{{ event.Percentage }}</td>
      </tr>
    </tbody>
  </table>
</div>
